module.exports = __webpack_public_path__ + "static/media/gradle.45e3aaeb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gradle.svg
// module id = 512
// module chunks = 0